import React from "react";
import classes from "../GuidedIntake.module.less";

export interface OptionCardProps {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    /** Optional tag shown right after the title (e.g. "Adaptive"). */
    tag?: string;
    onClick: () => void;
}

/**
 * A single chooser card — icon, title (+ optional tag), and subtitle. Shared by
 * the intake type-choice and mode-choice rows so both look and behave the same.
 */
export const OptionCard: React.FC<OptionCardProps> = ({
    icon,
    title,
    subtitle,
    tag,
    onClick,
}) => (
    <button type="button" className={classes.chooserCard} onClick={onClick}>
        <span className={classes.chooserCardIcon}>{icon}</span>
        <span className={classes.chooserCardText}>
            <span className={classes.chooserCardTitleRow}>
                <span className={classes.chooserCardLabel}>{title}</span>
                {tag && <span className={classes.chooserCardTag}>{tag}</span>}
            </span>
            <span className={classes.chooserCardSubtitle}>{subtitle}</span>
        </span>
    </button>
);

export default OptionCard;
